import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export default function Card({ children, className = '', onClick }: CardProps) {
  return (
    <div
      onClick={onClick}
      className={`bg-[#141414] thin-border rounded-lg ${onClick ? 'cursor-pointer hover:border-white/20 transition-all' : ''} ${className}`}
    >
      {children}
    </div>
  );
}
